import { findLinkRaiz, findMbDevice, findHost } from './../../services/fieldDataAdmin/querys/querys';
import { map, filter } from 'rxjs/operators';
import { fieldDataAdminService } from './../../services/fieldDataAdmin/field-data-admin-service.service';
import { getLocaleDateFormat } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, Pipe, TemplateRef } from '@angular/core';
import { nodeLink } from '../../services/fieldDataAdmin/models/models';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { ActivatedRoute } from '@angular/router';
import { result } from 'lodash';
import { IDropdownSettings } from 'ng-multiselect-dropdown/public_api';
import { Location } from '@angular/common';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { EditNodeComponent } from 'src/app/components/edit-node/edit-node.component';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-estructura-campo-admin',
    templateUrl: './estructura-campo-admin.component.html',
    styleUrls: ['./estructura-campo-admin.component.scss']
})
export class EstructuraCampoAdminComponent implements OnInit {

    constructor(private dataService: fieldDataAdminService, private cd: ChangeDetectorRef, private route: ActivatedRoute, private _location: Location, private modalService: NgbModal, private toastrservice: ToastrService) { }

    linksRaiz: any;
    rows: any[] = []; //change name
    lastIndex = 0;
    ColumnMode = ColumnMode;
    uuid: any;
    nombre: any;
    sub: any;
    extraVar: any[] = [];
    extraVarSelected: any[] = [];
    dropdownSettings: IDropdownSettings;
    closeResult = '';
    modalOptions: any = {
        centered: true,
        backdrop: false
    }

    ngOnInit() {
        this.extraVar = [
            { id: 1, name: "id", selected: false },
            { id: 2, name: "topic", selected: false },
            { id: 3, name: "gatewayTopic", selected: false },
            { id: 4, name: "address", selected: false },
            { id: 5, name: "ip", selected: false },
            { id: 6, name: "baudRate", selected: false },
            { id: 7, name: "dataBits", selected: false },
            { id: 8, name: "encoding", selected: false },
            { id: 9, name: "parity", selected: false },
            { id: 10, name: "path", selected: false },
            { id: 11, name: "stopBits", selected: false },
            { id: 12, name: "type", selected: false },
            { id: 13, name: "channel", selected: false },
            { id: 14, name: "modelo", selected: false },
            { id: 15, name: "port", selected: false },
            { id: 16, name: "timeout", selected: false },
            { id: 17, name: "wait", selected: false },
            { id: 18, name: "host", selected: false }];

        this.dropdownSettings = {
            singleSelection: false,
            idField: 'id',
            textField: 'name',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 5,
            allowSearchFilter: true
        };

        this.sub = this.route.params.subscribe(params => {
            this.uuid = params.uuid;
            this.nombre = params.nombre;
        });
        this.getData();
    }

    getData() {
        if (this.uuid != 0) {
            let descendancy: any[] = [];
            this.dataService.findNodeLinkElementDescendancy(this.uuid)
                .subscribe(({ data, loading }) => {
                    descendancy = data.findNodeLinkElementDescendancy.map(d => {
                        d = this.findNodeLinkExtraVars(d);
                        d['treeStatus'] = 'collapsed';
                        d['parentId'] = this.uuid;
                        return d;
                    });
                    this.rows = this.rows.concat(descendancy);
                    this.lastIndex = this.lastIndex + descendancy.length;
                    this.cd.detectChanges();
                })
        } else {
            this.dataService.findLinkRaiz()
                .subscribe(({ data, loading }) => {
                    this.linksRaiz = data;
                    this.rows = this.linksRaiz.findLinkRaiz;
                    this.lastIndex = this.rows.length;
                    this.rows = this.rows.map(d => {
                        d = this.findNodeLinkExtraVars(d);
                        d.treeStatus = 'collapsed';
                        d.parentId = null;
                        return d;
                    });
                })
        }

    }

    onTreeAction(event: any) {
        const index = event.rowIndex;
        const row = event.row;
        let descendancy: any[] = [];

        if (row.treeStatus === 'collapsed') {
            row.treeStatus = 'loading';

            this.dataService.findNodeLinkElementDescendancy(row.uuid)
                .subscribe(({ data, loading }) => {
                    descendancy = data.findNodeLinkElementDescendancy.map(d => {
                        d = this.findNodeLinkExtraVars(d);
                        d['treeStatus'] = 'collapsed';
                        d['parentId'] = row.uuid;
                        return d;
                    });
                    this.rows = this.rows.concat(descendancy)
                    this.lastIndex = this.lastIndex + descendancy.length;
                    row.treeStatus = 'expanded';
                    this.cd.detectChanges();
                })
        } else {
            row.treeStatus = 'collapsed';
            let sons = this.findDescendancy(row.uuid);
            this.rows = this.rows.filter(c => !sons.includes(c.uuid));
            this.lastIndex = this.rows.length;
            this.cd.detectChanges();
        }
    }

    findDescendancy(id: string): string[] {
        let data = this.rows;
        let sons: any[] = [];

        this.getTreeItem(data, id, sons);

        return sons;
    }

    getTreeItem(data: any, id: string, sons: any[]) {
        data.map(item => {
            if (item.parentId == id) {
                sons.push(item.uuid);
                this.getTreeItem(data, item.uuid, sons);
            }
        });
    }

    findNodeLinkExtraVars(node: any): any {
        node = {...node};
        node.labels.map(n => {

            switch (n) {
                case "Source":
                    this.dataService.findSource(node.uuid).subscribe(({ data, loading }) => {
                        node.topic = data.findSource.topic;
                        node.modelo = data.findSource.modelo;
                    })
                    break;
                case "MbDevice":
                    this.dataService.findMbDevice(node.uuid).subscribe(({ data, loading }) => {
                        node.address = data.findMbDevice.address;
                    })
                    break;
                case "MbRtu":
                    this.dataService.findMbRtuDevice(node.uuid).subscribe(({ data, loading }) => {
                        node.path = data.findMbRtu.path;
                    })
                    break;
                case "Host":
                    this.dataService.findHost(node.uuid).subscribe(({ data, loading }) => {
                        node.ip = data.findHost.ip;
                    })
                    break;
                case "MbTelnet":
                    this.dataService.findMbTelnet(node.uuid).subscribe(({ data, loading }) => {
                        node.ip = data.findMbTelnet.ip;
                        node.port = data.findMbTelnet.port;
                    })
                    break;
                case "MbBus":
                    this.dataService.findMbBus(node.uuid).subscribe(({ data, loading }) => {
                        node.baudRate = data.findMbBus.baudRate;
                        node.parity = data.findMbBus.parity;
                        node.dataBits = data.findMbBus.dataBits;
                        node.stopBits = data.findMbBus.stopBits;
                        node.timeout = data.findMbBus.timeout;
                        node.wait = data.findMbBus.wait;
                    })
                    break;
                case "MbTcp":
                    this.dataService.findMbTcp(node.uuid).subscribe(({ data, loading }) => {
                        node.host = data.findMbTcp.host;
                        node.port = data.findMbTcp.port;
                    })
                    break;
                case "Switch":
                    // this.dataService.findSwitch(node.uuid).subscribe(({ data, loading }) => {
                    // })
                default:
            }
        });
        return node;
    }

    onItemSelect(item: any) {
    }
    onSelectAll(items: any) {
    }

    returnVariable(row: any, colName: any): string {
        let result: string;

        switch (colName) {
            case "ip":
                result = row.ip;
                break;
            case "id":
                result = row.id;
                break;
            case "topic":
                result = row.topic;
                break;
            case "gatewayTopic":
                result = row.gatewayTopic;
                break;
            case "address":
                result = row.address;
                break;
            case "baudRate":
                result = row.baudRate;
                break;
            case "dataBits":
                result = row.dataBits;
                break;
            case "encoding":
                result = row.encoding;
                break;
            case "parity":
                result = row.parity;
                break;
            case "path":
                result = row.path;
                break;
            case "stopBits":
                result = row.stopBits;
                break;
            case "type":
                result = row.type;
                break;
            case "channel":
                result = row.channel;
                break;
            case "modelo":
                result = row.modelo;
                break;
            case "port":
                result = row.port;
                break;
            case "timeout":
                result = row.timeout;
                break;
            case "wait":
                result = row.wait;
                break;
            case "host":
                result = row.host;
                break;
            default:
                result = '';
                break;
        }

        return result;
    }

    //Edition and creation
    open(row: any) {
        const modalRef = this.modalService.open(EditNodeComponent, this.modalOptions );
        modalRef.componentInstance.row = row;


        modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
            this.rows = this.rows.filter(r => r.uuid !== receivedEntry.uuid);
            this.rows = this.rows.concat(receivedEntry);
        });

    }

    create(row: any) {
        const modalRef = this.modalService.open(EditNodeComponent, this.modalOptions);
        modalRef.componentInstance.row = row;
        modalRef.componentInstance.isAddMode = true;
        
        if(row.treeStatus === "expanded"){
            modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
                this.rows = this.rows.concat(receivedEntry);
            });
        }
    }

    createRootNode() {
        const modalRef = this.modalService.open(EditNodeComponent, this.modalOptions);
        modalRef.componentInstance.isAddMode = true;
        modalRef.componentInstance.isAddRoot = true;
        modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
            this.rows = this.rows.concat(receivedEntry);
        });
    }

    goBack() {
        this._location.back();
    }

    copiado(event: any) {
        if (event) {
            this.toastrservice.info('', 'uuid copiado al portapapeles',
                { closeButton: true, timeOut: 2000 });
        }
    }

}